import React from 'react';
import './breadcrumb.scss';
import Breadcrumb from '../breadcrumb';
import MyImage from '@/components/common/image';
import IconSearch from '@/assets/images/icons/icons-search1.svg';

export default function HeadingCenter({
  children,
  pageConfig = {},
  additionalPage = [],
  isSearch,
  img,
  info,
}) {
  const infoText = info || pageConfig.pageInfo;
  return (
    <header className="breadcrumb wrapper-card">
      {isSearch ? <MyImage src={IconSearch} className="search" /> : <MyImage src={img} />}
      <div className="detail-info">
        <Breadcrumb breadcrumb={[...pageConfig.breadcrumb, ...additionalPage]} />
        <p className="more-info">{infoText}</p>
      </div>
      <div className="action-btn">{children}</div>
    </header>
  );
}
